export function setActiveArea(activeArea) {
  return {
    type: 'SET_ACTIVE_AREA',
    payload: activeArea,
  };
}
